import { useState } from "react";

import { ProjectFormInput } from "@/app/(workspace)/_types/project";
import { uploadProjectFile } from "@/lib/firebase/services/upload";
import { AnalyticsService } from "@/lib/firebase/services/analytics";

export function useUploadFile() {
  const [error, setError] = useState<string | null>(null);
  const [uploading, setUploading] = useState(false);

  const upload = async (file: File, detail: ProjectFormInput, uuid: string) => {
    setError(null);
    setUploading(true);

    try {
      const result = await uploadProjectFile(file, detail, uuid);
      AnalyticsService.trackProjectUpload(result.docId);
      return result; // { docId, uuid, downloadUrl }
    } catch (err: any) {
      setError(err.message || "업로드 중 오류 발생");
      throw err;
    } finally {
      setUploading(false);
    }
  };

  return { upload, uploading, error };
}
